import en from './en.ts';
import ptBR from './pt-BR.ts';
import zh from './zh.ts';
import es from './es.ts';
import fr from './fr.ts';

// Supported buyer-portal locales. EN is the source of truth; the rest are
// scaffolds populated as we onboard markets. react-intl falls back to the
// message id's defaultMessage for unknown keys, so empty maps are safe.
export const SUPPORTED_LOCALES = ['en', 'pt-BR', 'zh', 'es', 'fr'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  'pt-BR': 'Português (Brasil)',
  zh: '中文',
  es: 'Español',
  fr: 'Français',
};

export const messagesByLocale: Record<Locale, Record<string, string>> = {
  en,
  'pt-BR': ptBR,
  zh,
  es,
  fr,
};

const LOCAL_STORAGE_KEY = 'caratuva.buyer-portal.locale';

export function detectInitialLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  const stored = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  if (stored && (SUPPORTED_LOCALES as readonly string[]).includes(stored)) {
    return stored as Locale;
  }
  const nav = window.navigator.language;
  for (const candidate of SUPPORTED_LOCALES) {
    if (nav.toLowerCase().startsWith(candidate.toLowerCase())) return candidate;
  }
  return DEFAULT_LOCALE;
}

export function persistLocale(locale: Locale): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LOCAL_STORAGE_KEY, locale);
}
